import { Hero } from '../sections/Hero';
import { Marquee } from '../components/Marquee';
import { BrandMarquee } from '../components/BrandMarquee';
import { ValueProps } from '../sections/ValueProps';
import { ServicesGrid } from '../sections/ServicesGrid';
import { WhyUs } from '../sections/WhyUs';
import { Audiences } from '../sections/Audiences';
import { Approach } from '../sections/Approach';
import { CoursesPreview } from '../sections/CoursesPreview';
import { EbookSection } from '../sections/EbookSection';
import { PortfolioTeaser } from '../sections/PortfolioTeaser';
import { Testimonials } from '../sections/Testimonials';
import { InsightsTeaser } from '../sections/InsightsTeaser';
import { CTASection } from '../components/CTASection';
import { BankPayment } from '../components/BankPayment';
import { usePageMeta } from '../components/ScrollToTop';

export default function Home() {
  usePageMeta(
    'TheBigHub — Your Digital Growth Partner | Digital Marketing & Creative Solutions',
    'TheBigHub helps businesses get discovered, attract the right audience, and turn digital visibility into real opportunities. One Hub. Many Solutions. Maximum Impact.'
  );
  return (
    <main data-testid="home-page">
      <BrandMarquee />
      <Hero />
      <Marquee />
      <ValueProps />
      <ServicesGrid />
      <WhyUs />
      <Audiences />
      <Approach />
      <CoursesPreview />
      <EbookSection />
      <PortfolioTeaser />
      <Testimonials />
      <InsightsTeaser />
      <section data-testid="home-payment-section" className="bg-white">
        <div className="mx-auto max-w-7xl px-5 pb-20 sm:px-8 sm:pb-28">
          <BankPayment />
        </div>
      </section>
      <CTASection />
    </main>
  );
}
